(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn)=>el&&el.addEventListener(ev,fn);
const isPage=(...t)=>t.some(p=>document.body.classList.contains('template-'+p));

function initCursor(){
  if(window.innerWidth<1025)return;
  const cursor=document.createElement('div');
  cursor.id='ma-cursor';
  cursor.innerHTML='<div class="ma-cursor-dot"></div><div class="ma-cursor-ring"></div><span class="ma-cursor-label"></span>';
  document.body.appendChild(cursor);
  const dot=cursor.querySelector('.ma-cursor-dot');
  const ring=cursor.querySelector('.ma-cursor-ring');
  const label=cursor.querySelector('.ma-cursor-label');
  let mx=-100,my=-100,rx=-100,ry=-100;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;dot.style.transform=`translate(${mx}px,${my}px)`;});
  function animateRing(){rx+=(mx-rx)*.12;ry+=(my-ry)*.12;ring.style.transform=`translate(${rx}px,${ry}px)`;label.style.transform=`translate(${rx}px,${ry}px)`;requestAnimationFrame(animateRing);}
  animateRing();
  const hoverTargets=[
    {sel:'.product-item,.product-holder',text:'VOIR',expand:true},
    {sel:'button[type="submit"],.product-form__submit',text:'DROP',expand:true,red:true},
    {sel:'a[href*="/collections"]',text:'SHOP',expand:false},
    {sel:'.btn,.button',text:'',expand:true},
  ];
  function bindHovers(){
    hoverTargets.forEach(({sel,text,expand,red})=>{
      $$(sel).forEach(el=>{
        on(el,'mouseenter',()=>{ring.classList.add('is-hovering');if(expand)ring.classList.add('is-expanded');if(red)ring.classList.add('is-red');if(text)label.textContent=text;});
        on(el,'mouseleave',()=>{ring.classList.remove('is-hovering','is-expanded','is-red');label.textContent='';});
      });
    });
  }
  bindHovers();
}

function initStickyATC(){
  if(!isPage('product'))return;
  const form=$('.product-form__submit');
  if(!form)return;
  const productTitle=$('h1.title,.product__title')?.textContent?.trim()||'Cette pi\u00e8ce';
  const bar=document.createElement('div');
  bar.id='ma-sticky-atc';
  bar.innerHTML=`<div class="ma-sticky-left"><span class="ma-sticky-name">${productTitle}</span></div><button class="ma-sticky-btn" id="ma-sticky-btn"><span class="btn-text">Ajouter au drop</span><span class="btn-icon">\u2192</span></button>`;
  document.body.appendChild(bar);
  const stickyBtn=bar.querySelector('#ma-sticky-btn');
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(e=>{bar.classList.toggle('is-visible',!e.isIntersecting);});
  },{threshold:0.1});
  observer.observe(form);
  on(stickyBtn,'click',()=>{
    stickyBtn.classList.add('is-loading');
    stickyBtn.querySelector('.btn-text').textContent='...';
    setTimeout(()=>{
      form.click();
      stickyBtn.classList.remove('is-loading');
      stickyBtn.classList.add('is-success');
      stickyBtn.querySelector('.btn-text').textContent='\u2713 Ajout\u00e9';
      setTimeout(()=>{stickyBtn.classList.remove('is-success');stickyBtn.querySelector('.btn-text').textContent='Ajouter au drop';},2000);
    },400);
  });
}

function initScrollReveals(){
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){setTimeout(()=>e.target.classList.add('is-visible'),parseInt(e.target.dataset.delay)||0);io.unobserve(e.target);}
    });
  },{threshold:0.12});
  const targets=['.product-item','.section__title','.section-title','.box__heading','.caption','.product__title','.product__price'];
  targets.forEach(sel=>{
    $$(sel).forEach((el,i)=>{el.classList.add('ma-reveal');el.dataset.delay=(i%4)*80;io.observe(el);});
  });
}

function initCTARewrite(){
  const rewrites=[
    {original:/ajouter au panier/i,replace:'Ajouter au drop'},
    {original:/add to cart/i,replace:'Add to drop'},
    {original:/acheter maintenant/i,replace:'Je la prends \u2192'},
    {original:/buy it now/i,replace:'Je la prends \u2192'},
  ];
  $$('button,.btn').forEach(btn=>{
    rewrites.forEach(({original,replace})=>{
      if(original.test(btn.textContent)){
        const spans=btn.querySelectorAll('span:not(.visually-hidden)');
        if(spans.length)spans.forEach(s=>{if(original.test(s.textContent))s.textContent=replace;});
      }
    });
  });
}

function initATCAnimation(){
  $$('.product-form__submit').forEach(btn=>{
    on(btn,'click',()=>{
      btn.classList.add('ma-atc-loading');
      setTimeout(()=>{
        btn.classList.remove('ma-atc-loading');
        btn.classList.add('ma-atc-success');
        const s=btn.querySelector('span:not(.visually-hidden)');
        const orig=s?.textContent;
        if(s)s.textContent='\u2713 Dans ton drop';
        setTimeout(()=>{btn.classList.remove('ma-atc-success');if(s&&orig)s.textContent=orig;},2500);
      },800);
    });
  });
}

/* LIVE NOTIFICATIONS — produits OVER */
function initLiveNotifications(){
  if(window.innerWidth<=1024)return;
  const products=[
    'Veste Simili-Cuir OVER',
    'Tee-Shirt Rose OVER',
    'Veste Simili-Cuir OVER R\u00e9\u00e9dition'
  ];
  const cities=['Paris','Lyon','Marseille','Bordeaux','Lille','Nantes','Toulouse','Strasbourg','Rennes','Nice'];
  const names=['Lucas','Mathis','Noah','L\u00e9o','Emma','Jade','In\u00e8s','Camille','Th\u00e9o','Antoine','Nour','Sarah'];
  const times=['\u00e0 l\'instant','il y a 2 min','il y a 5 min','il y a 8 min'];
  const notif=document.createElement('div');
  notif.id='ma-live-notif';
  notif.innerHTML=`<div class="ma-notif-img"></div><div class="ma-notif-text"><strong class="ma-notif-name"></strong><span class="ma-notif-action"> vient d'acheter </span><span class="ma-notif-product"></span><br><span class="ma-notif-time"></span></div><button class="ma-notif-close">\u00d7</button>`;
  document.body.appendChild(notif);
  on(notif.querySelector('.ma-notif-close'),'click',()=>notif.classList.remove('is-visible'));
  let notifTimer=null;
  function showNotif(){
    if(notif.classList.contains('is-visible'))return;
    notif.querySelector('.ma-notif-name').textContent=names[Math.floor(Math.random()*names.length)]+' \u2014 '+cities[Math.floor(Math.random()*cities.length)];
    notif.querySelector('.ma-notif-product').textContent=products[Math.floor(Math.random()*products.length)];
    notif.querySelector('.ma-notif-time').textContent=times[Math.floor(Math.random()*times.length)];
    notif.classList.add('is-visible');
    if(notifTimer)clearTimeout(notifTimer);
    notifTimer=setTimeout(()=>notif.classList.remove('is-visible'),4000);
  }
  setTimeout(showNotif,20000);
  setInterval(showNotif,90000);
}

function initGrainOverlay(){
  const grain=document.createElement('div');
  grain.id='ma-grain';
  document.body.appendChild(grain);
}

function initParallax(){
  if(window.innerWidth<768)return;
  const heroes=$$('.banner,[class*="banner--"]');
  window.addEventListener('scroll',()=>{
    heroes.forEach(hero=>{
      const rect=hero.getBoundingClientRect();
      if(rect.bottom>0&&rect.top<window.innerHeight){
        const img=hero.querySelector('img');
        if(img)img.style.transform=`translateY(${window.scrollY*.12}px) scale(1.05)`;
      }
    });
  },{passive:true});
}

function init(){
  initCursor();
  initScrollReveals();
  initCTARewrite();
  initATCAnimation();
  initGrainOverlay();
  initParallax();
  initLiveNotifications();
  if(document.body.classList.contains('template-product'))setTimeout(initStickyATC,600);
}

if(document.readyState!=='loading')init();
else document.addEventListener('DOMContentLoaded',init);
})();